import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { AnimationComponentProps } from '../types';

const breathe = (startScaleAt: number) =>
  keyframes`0%{ 
    opacity: 0;
    scale: ${startScaleAt};

 }
 100% {
    scale: 1;
    opacity: 1;
 }
`;

const BreatheAnimation = styled.div<{
  speed: number;
  startScaleAt: number;
  delay: number;
  easeFunction: string;
}>`
  animation: ${(props) => breathe(props.startScaleAt)} ${(props) => props.speed}s
    ${(props) => props.delay}s ${(props) => props.easeFunction};
`;

export const BREATHE_DEFAULT_SPEED = 0.45;

export const Breathe = (props: AnimationComponentProps) => {
  const {
    children,
    speed = BREATHE_DEFAULT_SPEED,
    startScaleAt = 0.92,
    delay,
    easeFunction = 'cubic-bezier(0.1, 0, 0.1, 1)',
  } = props;

  return (
    <BreatheAnimation
      speed={speed}
      startScaleAt={startScaleAt}
      easeFunction={easeFunction}
      delay={delay || 0}
    >
      {children}
    </BreatheAnimation>
  );
};
